import React, { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

export function SidebarProvider({ children }) {
    const [isFilterSidebarOpen, setFilterSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setFilterSidebarOpen((prev) => !prev);
    };

    return (
        <SidebarContext.Provider value={{ isFilterSidebarOpen, setFilterSidebarOpen, toggleSidebar }}>
            {children}
        </SidebarContext.Provider>
    );
}

export function useSidebar() {
    return useContext(SidebarContext);
}
